import React from "react";
import { connect } from "react-redux";
import Select from 'react-select';

import "./EditSubUnits.css"

import { getAllUnits, setOuName, getOuName, getOuSubUnits, editOuSubUnits } from "../../../../../actions/structureActions";

class EditSubUnits extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            addOperations: {},
            updateOperations: {},
            deleteOperations: {},
            changeErrors: []
        };
        this.state = this.initialState;
    }

    componentDidMount() {
        this.props.getAllUnits();
        if (this.props.match.params.ouID) this.props.getOuName(this.props.match.params.ouID);
        else this.props.setOuName();
        this.props.getOuSubUnits(this.props.match.params.ouID ? this.props.match.params.ouID : null);
    }

    onNewAdd = () => this.setState({ addOperations: {
        ...this.state.addOperations, [-1 * (Object.keys(this.state.addOperations).length + 100)]: {
            ouID: -1 * (Object.keys(this.state.addOperations).length + 100), symbol: "", name: "", sort: 1, parentOuID: null
        }
    } });

    onRowUpdate = (subUnit, value, field, isNew) => {
        if (isNew) this.setState({ addOperations: { ...this.state.addOperations,
            [subUnit.ouID]: { ...this.state.addOperations[subUnit.ouID], [field]: value }
        } });
        else this.setState({ updateOperations: { ...this.state.updateOperations,
            [subUnit.ouID]: this.state.updateOperations[subUnit.ouID] ? (
                JSON.stringify({ ...this.state.updateOperations[subUnit.ouID], [field]: value }) !== JSON.stringify(subUnit) ?
                { ...this.state.updateOperations[subUnit.ouID], [field]: value } : null
            ) : { ...subUnit, [field]: value }
        } });
    };

    onNewChange = (ouID, value) => {
        if (ouID !== null) this.setState({ addOperations: { ...this.state.addOperations, [ouID]: null, [value.value.ouID]: value.value } });
        else this.setState({ addOperations: { ...this.state.addOperations, [value.value.ouID]: value.value } });
    }

    onRowDelete = (subUnit) => {
        this.setState({ deleteOperations: { ...this.state.deleteOperations, [subUnit.ouID]: this.state.deleteOperations[subUnit.ouID] ? null : subUnit } });
    };

    onNewDelete = (ouID) => {
        this.setState({ addOperations: { ...this.state.addOperations, [ouID]: null } });
    };

    onChangesApply = () => {
        const formValues = {
            addOperations: [...Object.keys(this.state.addOperations).map(key => this.state.addOperations[key] ? {
                ouID: this.state.addOperations[key].ouID, symbol: this.state.addOperations[key].symbol, name: this.state.addOperations[key].name, sort: this.state.addOperations[key].sort
            } : null).filter(v => v !== null)],
            updateOperations: [...Object.keys(this.state.updateOperations).map(key => (this.state.updateOperations[key] && !this.state.deleteOperations[key]) ? {
                ouID: this.state.updateOperations[key].ouID, symbol: this.state.updateOperations[key].symbol, name: this.state.updateOperations[key].name, sort: this.state.updateOperations[key].sort, parentOuID: this.state.updateOperations[key].destination.value ? this.state.updateOperations[key].destination.value.ouID : this.state.updateOperations[key].parentOuID
            } : null).filter(v => v !== null)],
            deleteOperations: [...Object.keys(this.state.deleteOperations).map(key => this.state.deleteOperations[key] ? this.state.deleteOperations[key].ouID : null).filter(v => v !== null)]
        };
        this.props.editOuSubUnits(this.props.match.params.ouID ? this.props.match.params.ouID : null, formValues, this.onChangeSuccess, this.onChangeError);
    };

    onChangeSuccess = () => this.setState(this.initialState);

    onChangeError = ({ data }) => this.setState({ changeErrors: data.error });

    renderError = error => {
        return error ? (
            <div className="ui error message">
                {error.message.map((line, index) => <p key={index}>{line}</p>)}
            </div>
        ) : null;
    }

    renderUnitsOptions = (prefix, units) => {
        let options = []
        units.forEach(unit => {
            options.push({ label: `${prefix} ${unit.symbol} | ${unit.name}`, value: unit });
            options = [
                ...options,
                ...this.renderUnitsOptions(`${prefix}_`, unit.subOUs)
            ]
        })
        return options
    };

    renderRows = () => this.props.subUnits.map(subUnit => {
        return (
            <div key={subUnit.ouID} className={`ui ${this.state.deleteOperations[subUnit.ouID] ? "secondary red " : this.state.updateOperations[subUnit.ouID] ? "secondary yellow " : ""}segment`}>
                {this.renderRow(subUnit, false)}
            </div>
        );
    });

    renderNewRows = () => Object.keys(this.state.addOperations).map(key => {
        return (this.state.addOperations[key] ? (
            <div key={key} className="ui secondary green segment">
                {this.renderRow(this.state.addOperations[key], true)}
            </div>
        ) : <React.Fragment key={key} />);
    });

    renderRow = (subUnit, isNew) => {
        let rowErrors = {};
        if (subUnit) {
            rowErrors = {
                symbol: this.state.changeErrors.filter(err => err.field === "symbol" && err.ouID === subUnit.ouID)[0],
                name: this.state.changeErrors.filter(err => err.field === "name" && err.ouID === subUnit.ouID)[0],
                sort: this.state.changeErrors.filter(err => err.field === "sort" && err.ouID === subUnit.ouID)[0],
                destination: this.state.changeErrors.filter(err => err.field === "destination" && err.ouID === subUnit.ouID)[0]
            };
        }

        if (subUnit && !isNew) subUnit.destination = { label: "< Bez zmian >", value: null };
        return (
            <div className={`ui ${subUnit ? "" : "header "}grid`}>
                <div className="row">
                    {!isNew ? (
                        <div className="two wide column">
                            <div className="content">{subUnit ? subUnit.ouID : "Numer jednostki"}</div>
                        </div>
                    ) : null}
                    <div className={`${isNew ? "four" : "three"} wide column`}>
                        <div className="content">{subUnit ? (
                            <div className="ui form error warning">
                                <input
                                    disabled={this.state.deleteOperations[subUnit.ouID] !== null && this.state.deleteOperations[subUnit.ouID] !== undefined}
                                    type="text"
                                    value={
                                        isNew ? this.state.addOperations[subUnit.ouID].symbol :
                                        this.state.updateOperations[subUnit.ouID] ? this.state.updateOperations[subUnit.ouID].symbol : subUnit.symbol
                                    }
                                    onChange={value => this.onRowUpdate(subUnit, value.target.value, "symbol", isNew)}
                                />
                                {this.renderError(rowErrors.symbol)}
                            </div>
                        ) : "Symbol"}</div>
                    </div>
                    <div className={`${isNew ? "four" : "three"} wide column`}>
                        <div className="content">{subUnit ? (
                            <div className="ui form error warning">
                                <input
                                    disabled={this.state.deleteOperations[subUnit.ouID] !== null && this.state.deleteOperations[subUnit.ouID] !== undefined}
                                    type="text"
                                    value={
                                        isNew ? this.state.addOperations[subUnit.ouID].name :
                                        this.state.updateOperations[subUnit.ouID] ? this.state.updateOperations[subUnit.ouID].name : subUnit.name
                                    }
                                    onChange={value => this.onRowUpdate(subUnit, value.target.value, "name", isNew)}
                                />
                                {this.renderError(rowErrors.name)}
                            </div>
                        ) : "Nazwa"}</div>
                    </div>
                    <div className={`${isNew ? "four" : "three"} wide column`}>
                        <div className="content">{subUnit ? (
                            <div className="ui form error warning">
                                <input
                                    disabled={this.state.deleteOperations[subUnit.ouID] !== null && this.state.deleteOperations[subUnit.ouID] !== undefined}
                                    type="number"
                                    value={
                                        isNew ? this.state.addOperations[subUnit.ouID].sort :
                                        this.state.updateOperations[subUnit.ouID] ? this.state.updateOperations[subUnit.ouID].sort : subUnit.sort
                                    }
                                    onChange={value => this.onRowUpdate(subUnit, +value.target.value, "sort", isNew)}
                                />
                                {this.renderError(rowErrors.sort)}
                            </div>
                        ) : "Kolejność"}</div>
                    </div>
                    {!isNew ? (
                        <div className="three wide overflow column">
                            {subUnit ? (
                                <div className="ui form error warning">
                                    <Select
                                        isDisabled={this.state.deleteOperations[subUnit.ouID] !== null && this.state.deleteOperations[subUnit.ouID] !== undefined}
                                        value={this.state.updateOperations[subUnit.ouID] ? this.state.updateOperations[subUnit.ouID].destination : { label: "< Bez zmian >", value: null }}
                                        onChange={value => this.onRowUpdate(subUnit, value, "destination", isNew)}
                                        options={[{ label: "< Bez zmian >", value: null }, { label: "Medcom", value: { ouID: null } }, ...this.renderUnitsOptions("_", this.props.unitsList)]}
                                        placeholder="Jednostka organizacyjna"
                                        noOptionsMessage={() => "Nie znaleziono jednostki organizacyjnej"}
                                        maxMenuHeight="400px"
                                    />
                                    {this.renderError(rowErrors.destination)}
                                </div>
                            ) : "Przenieś do"}
                        </div>
                    ) : null}
                    <div className={`${isNew ? "four" : "two"} wide overflow column`}>
                        {subUnit ? (
                            <button className="ui button" onClick={() => isNew ? this.onNewDelete(subUnit.ouID) : this.onRowDelete(subUnit)}>{isNew ? "Anuluj" : this.state.deleteOperations[subUnit.ouID] ? "Cofnij" : "Usuń"}</button>
                        ) : null}
                    </div>
                </div>
            </div>
        )
    };

    renderChanges = () => {
        const changes = [
            ...Object.keys(this.state.addOperations).map(key => this.renderChange(this.state.addOperations[key], key, "add")),
            ...Object.keys(this.state.updateOperations).map(key => this.renderChange(this.state.updateOperations[key], key, "update")),
            ...Object.keys(this.state.deleteOperations).map(key => this.renderChange(this.state.deleteOperations[key], key, "delete"))
        ].filter(v => v !== null);

        return changes.length ? (
            <React.Fragment>
                <div className="ui divider" />
                <div className="ui secondary blue segment">
                    <div className="ui header">
                        <div className="content">Wykaz zmian</div>
                    </div>
                    {changes}
                </div>
                <button className="ui primary button" onClick={this.onChangesApply}>Zatwierdź</button>
                <button className="ui button" onClick={() => this.setState(this.initialState)}>Anuluj</button>
            </React.Fragment>
        ) : null;
    };

    renderChange = (operation, key, type) => {
        return (operation && (type !== "update" || (type === "update" && !this.state.deleteOperations[key]))) ? (
            <div key={`${type}${operation.ouID}`} className={`${type === "add" ? "green" : type === "update" ? "yellow" : "red"} content`}>
                {type === "add" ? "Dodano" : type === "update" ? "Zmodyfikowano" : "Usunięto"} jednostkę&nbsp;
                <b>{operation.symbol} | {operation.name}</b>&nbsp;
                {type !== "update" ? (
                    <React.Fragment>
                        {type === "add" ? "do" : "z"} jednostki&nbsp;
                        <b>{this.props.ouName}</b>
                    </React.Fragment>
                ) : null}
            </div>
        ) : null;
    };

    render() {
        return (
            <React.Fragment>
                <div className="edit-sub-units-component ui container">
                    <div className="ui container">
                        <div className="ui header">
                            <div className="content">{`Jednostki podległe pod: ${this.props.match.params.ouID ? this.props.ouName : "Medcom"}`}</div>
                        </div>
                        <div className="ui divider" />
                        {this.props.subUnits.length ? (
                            <React.Fragment>
                                {this.renderRow()}
                                {this.renderRows()}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div className="ui small header">
                                    <div className="content">Brak jednostek podległych</div>
                                </div>
                                <div className="ui divider" />
                            </React.Fragment>
                        )}
                        {Object.keys(this.state.addOperations).find(key => this.state.addOperations[key]) ? this.renderRow(null, true) : null}
                        {this.renderNewRows()}
                        <button className="ui primary button" onClick={this.onNewAdd}>Dodaj</button>
                        {this.renderChanges()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    unitsList: state.structure.list,
    ouName: state.structure.edit.name,
    subUnits: state.structure.edit.subUnits
});

export default connect(mapStateToProps, { getAllUnits, setOuName, getOuName, getOuSubUnits, editOuSubUnits })(EditSubUnits);